import { usePrices } from '@api/usePrices'
import { useSupplyManagementContext } from '@components/SupplyManagement/contexts/SupplyManagementContext'
import { GraviGrid } from '@gravitate-js/excalibrr'
import { useUserSettings } from '@hooks/settings'
import type { GridApi } from 'ag-grid-community'
import { useRef } from 'react'

import { getColumnDefs } from './columnDefs'
import { OutageActionButtons } from './components/OutageActionButtons'
import { OutageQueryStatusIndicator } from './components/OutageQueryStatusIndicator'

const OUTAGE_GRID_KEY = 'outage-grid'

export function OutageGrid() {
  const { updateSetting } = useUserSettings()
  const { openEditOutage, headerFilters, handleUpdateHeaderFilters } = useSupplyManagementContext()
  const { useSupplyOutageQuery } = usePrices()
  const { data, isLoading, isRefetching } = useSupplyOutageQuery(headerFilters)
  const columnDefs = getColumnDefs(openEditOutage)

  const gridAPIRef = useRef<GridApi>(null)
  const columnApiRef = useRef(null)
  const contextMenuItems = ['copy', 'copyWithHeaders', 'separator', 'export', 'separator', 'resetColumns']

  return (
    <GraviGrid
      columnDefs={columnDefs}
      externalRef={gridAPIRef}
      columnApiRef={columnApiRef}
      agPropOverrides={{
        getContextMenuItems: () => contextMenuItems,
      }}
      controlBarProps={{
        title: 'Outages',
        serverParams: data?.data.params,
        hiddenFilterKeys: ['as_of'],
        actionButtons: (
          <>
            <OutageQueryStatusIndicator isLoading={isRefetching} />
            <OutageActionButtons
              headerFilters={headerFilters}
              setHeaderFilters={handleUpdateHeaderFilters}
              handleEditOutage={openEditOutage}
              gridAPIRef={gridAPIRef}
            />
          </>
        ),
      }}
      loading={isLoading}
      storageKey={OUTAGE_GRID_KEY}
      rowData={data?.data || []}
      onGridConfigChanged={(config) => updateSetting(`gridConfig::${OUTAGE_GRID_KEY}`, config)}
    />
  )
}
